export enum Unit {
  PIECES = "pcs",
  METER = "m",
  CENTIMETER = "cm",
  MILLIMETER = "mm",
  FOOT = "ft",
  INCH = "in",
  GRAM = "g",
  KILOGRAM = "kg",
  POUNDS = "lbs",
  LITER = "l",
  MILLILITER = "ml",
  GALLON = "gal",
  OUNCE = "oz",
  FLUID_OUNCE = "fl oz",
  PINT = "pt",
}
